export default __webpack_public_path__ + "locales/de/ChangeUserTypeDialog.json?hash=b1ca8699c308ec99fa084f5cc4a73e92";